<div class="bk-dialog bk-dialog__event">
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

	<h4 mat-dialog-title>
		<ng-container *ngIf="data && data.well"
			class="bk-modal__header-title">
			{{'Edit' | translate }} {{'Water Source' | translate }}
		</ng-container>
		<ng-container *ngIf="!data || !data.well"
			class="bk-modal__header-title">
			{{'Add' | translate }} {{'Water Source' | translate }}
		</ng-container>
	</h4>

	<div mat-dialog-content>
		<ranch-well-form
			[well]="data ? data.well : null"
			(onCancel)="closeFinal()"
			(onHide)="hide()"
			(onShow)="show()"
			(onSubmit)="submit($event)">
		</ranch-well-form>
	</div>

	<div mat-dialog-actions
		align="end">
		<button mat-button
			class="bk-button bk-button--medium bk-button--text-only bk-dialog__button--secondary"
			(click)="close()">
			{{ 'Cancel' | translate }}
		</button>
		<button mat-button
			class="bk-button bk-button--medium"
			[disabled]="!wellForm || !wellForm.isValid"
			(click)="wellForm.submit()">
			{{ (data && data.well ? 'Save' : 'Add') | translate }} {{'Water Source' | translate }}
		</button>
	</div>
</div>
